export function isNested(obj) {
  return 'subheading' in obj && (Array.isArray(obj.options) || Array.isArray(obj.actions));
}